import { ChiptaElement, html, css, unsafeCSS } from 'chipta-libs/main.js';
import groupState from './state/group.js';
import './list-item';


class EventGroupDetails extends ChiptaElement {

  static get properties() {
    return {
      group: {type: Object}
    };
  }

  render () {
    return html`
      <list-item @click=${this.selectGroup}>
        ${this.group.name}
      </list-item>
    `;
  }

  selectGroup() {
    groupState.selectedGroup = this.group;
  }

}

customElements.define('event-group-details', EventGroupDetails);
